export const getUserAgent = () => {
    const iOS = (
        [
            "iPad Simulator",
            "iPhone Simulator",
            "iPod Simulator",
            "iPad",
            "iPhone",
            "iPod",
        ].includes(navigator.platform) || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    ) && !window.MSStream;

    const firefox = /Firefox/.test(navigator.userAgent) && !window.MSStream;
    const android = /Android/.test(navigator.userAgent) && !window.MSStream;
    const isMobile = /Mobile/.test(navigator.userAgent) && !window.MSStream;

    return {
        iOS: iOS,
        firefox: firefox,
        android: android,
        isMobile: isMobile
    }
}